import { useSelector } from 'react-redux';
import { AlertMessage } from 'app/components/AlertMessage';
import { useQuery} from "@tanstack/react-query";
import { UserBookCover } from './UserBookCover';
import { KeepButton } from "./KeepButton";
import { getUserBook } from '../apiUserBook';
import { ButtonUserBookDelete } from './button/ButtonUserBookDelete';
import { ButtonUserBookTitle } from './button/ButtonUserBookTitle';
import { ButtonUserBookNewEpisode } from './button/ButtonUserBookNewEpisode';
import { ButtonUserBookFirstEpisode } from './button/ButtonUserBookFirstEpisode';
import { ButtonUserBookEpisodeList } from './button/ButtonUserBookEpisodeList';
import { ButtonUserBookComplete } from './button/ButtonUserBookComplete';

export const UserBookInfo = ({ bookId, useDelete = false, isEpisodeListPage=false }) => {
    const auth = useSelector(state => state.auth);
    
    const { data:userBook, isError} = useQuery({
        queryKey:['userbook', bookId],
        queryFn:getUserBook,
    });


    // if( isLoading ) return null;
    if( isError ) return null;

    return (
        <div className={`userBookInfo subHeader ${userBook?.data?.deleteYn === "Y" ? "deleteContainer" : ""}`}>
            <div className="inner">
                <AlertMessage type="delete" visible={userBook?.data?.deleteYn === "Y"} />
                <div className="userBookInfoBox">
                    <UserBookCover bookId={bookId} image={userBook?.data?.image} alt={userBook?.data?.subject}
                                    creative={userBook?.data?.creative === "Y"}
                                    editiable={userBook?.data?.userId === auth.id && userBook?.data?.deleteYn !== 'Y' && !userBook?.data?.completed}
                    />

                    <div className="info">
                        <h4 className="title"> {userBook?.data?.completed&&<strong className='completed-text'>[완결]</strong>} {userBook?.data?.subject} </h4>
                        <div className="writer">{userBook?.data?.schoolName}
                            <strong className="userName">{userBook?.data?.userName || userBook?.data?.name}</strong>작가님
                            {auth.authenticated && userBook?.data?.deleteYn !== 'Y' && <KeepButton book={userBook?.data} /> }
                        </div>
                        <div className="controls">
                            <ButtonUserBookFirstEpisode episodeId={userBook?.data?.firstEpisodeId} isEpisodeListPage={isEpisodeListPage} />
                            <ButtonUserBookEpisodeList bookId={bookId} isEpisodeListPage={isEpisodeListPage} />
                            {userBook?.data?.userId === auth.id && userBook?.data?.deleteYn !== 'Y' &&
                                <>
                                    <ButtonUserBookComplete bookId={bookId} completed={userBook?.data?.completed} episodeCount={userBook?.data?.episodeCount} />
                                    <ButtonUserBookNewEpisode bookId={bookId} use={!userBook?.data?.completed} />
                                    <ButtonUserBookTitle bookId={bookId} use={!userBook?.data?.completed} />
                                    {useDelete && <ButtonUserBookDelete bookId={bookId} />}
                                </>
                            }

                        </div>
                    </div>

                </div>
            </div>
        </div>

    );
};